/**
 * Header component
 */


 import React from 'react'
 import layoutStyles from './layoutStyles.module.css'
 import { Link } from 'gatsby'

 const Header = () => {
   return(
     <header className = {layoutStyles.navHeader}>
      <p className = {layoutStyles.title}>
        Designing Programs 2022/23
      </p>
      <p> 
      <Link className = {layoutStyles.link} to='/'>Home | </Link> 
      <Link className = {layoutStyles.link} to='/course'>Course | </Link>
      <Link className = {layoutStyles.link} to='/resources'>Resources</Link>
      </p>
     </header>
   )
 }

 export default Header
